import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CollapseList from "~/ui/ReactML/CollapseList";
import Icon from "~/ui/ReactML/Icon";
import { Col, Row, IconButton, View, VStack, WithBaseStyles, renderHTML } from '~/native-ui';
import { HighLightText } from '../../../native-ui';
import { List } from "~/native-ui/List";

const StyledCollapseList = WithBaseStyles(CollapseList, {
    defaultProps: {
        mt: "1",
        space: "1",
    }
})




export default class MessageList extends Component {
    static propTypes = {
        messages: PropTypes.array.isRequired,
        level: PropTypes.number,
        className: PropTypes.string,
        hideMessages: PropTypes.func,
    };

    formatMessage = (mData, i) => {
        let message = renderHTML(mData.message, {ul: StyledCollapseList, li: List.Item, icon: Icon, });

        let highlightTextLevel = {
            danger: "error",
            validation_error: "error",
            success: "success",
            warning: "warning",
        }
        
        return (
            <HighLightText data-highlight={highlightTextLevel[mData.type]} key={i+""}>
                <VStack color="inherit" flexDirection="column" py={0} alignItems="flex-start" key={mData.message}>
                    {message}
                </VStack>
            </HighLightText>
        );
    };

    render() {
        let { messages } = this.props;

        if(!messages.length) { return null; }

        let renderedMessages = messages.map(this.formatMessage);

        return (
            <Row mb={4}>
                <Col shadow={ 1 } space={ 0 } xs={ 12 }>
                    <VStack space="1" ol={false} ul={false} border={ 0 } py={ 0 }>
                        {renderedMessages}
                    </VStack>
                    {
                        this.props.hideMessages &&
                        <View position="absolute" top={ .5 } right={ .5 } ><IconButton type={'close'} onClick={this.props.hideMessages} /></View>
                    }
                </Col>
            </Row>
        );
    }
}